import { readFromStorage } from './readFromStorage';
import { writeToStorage } from './writeToStorage';

/** Call when the survey is displayed. Starts the 7-day soft cooldown. */
export const recordCsatDisplayed = (): void => {
	const cur = readFromStorage();
	writeToStorage({
		...cur,
		lastShownAt: Date.now(),
		qualifyingConversations: 0,
	});
};
